var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArty(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "arty_svg__Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 699.37 811.14",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".arty_svg__cls-2{fill:#fa505e}.arty_svg__cls-3{fill:#024447}.arty_svg__cls-5{fill:#fff}.arty_svg__cls-6{fill:#fd934f}.arty_svg__cls-8{fill:#2a848e}.arty_svg__cls-11,.arty_svg__cls-9{stroke:#fa505e;fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:16px}.arty_svg__cls-11{stroke:#006c78}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arty_svg__Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "arty_svg__cls-8",
    d: "M141.77 620.24v53.29c0 14.23-11.53 25.76-25.76 25.76h-6.02c-14.23 0-25.76 11.53-25.76 25.76 0 14.23 11.53 25.76 25.76 25.76h153.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "arty_svg__cls-6",
    d: "M421.85 738.53h100.12c17.83 0 32.31 14.48 32.31 32.31v21.02c0 6.23-5.06 11.29-11.29 11.29H421.85c-17.83 0-32.31-14.48-32.31-32.31 0-17.83 14.48-32.31 32.31-32.31z",
    transform: "rotate(-180 471.91 770.835)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "arty_svg__cls-9",
    d: "M388.54 738.82l1 32.02c0 17.77 14.54 32.31 32.31 32.31h100.12c17.77 0 32.31-14.54 32.31-32.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.16 573.34c12.74 16.6 4.97 40.74-15.02 46.95-52.2 16.22-111.23-.63-146.44-46.53-43.94-57.27-34.6-138.65 20.17-184.59l141.29 184.16z",
    fill: "#006c78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "arty_svg__cls-11",
    d: "M678.14 620.29c-52.2 16.22-111.23-.63-146.44-46.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "arty_svg__cls-8",
    d: "M578.45 309.16v321.65c0 62.9-48.41 114.51-110 119.58-3.29.28-6.63.42-10 .42H240.92c-3.37 0-6.71-.14-10-.42-61.6-5.07-110-56.68-110-119.58V309.16c0-126.34 102.42-228.76 228.76-228.76 63.17 0 120.36 25.6 161.76 67 41.4 41.4 67.01 98.59 67.01 161.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "arty_svg__cls-8",
    d: "M6.21 573.34c-12.74 16.6-4.97 40.74 15.02 46.95 52.2 16.22 111.23-.63 146.44-46.53 43.94-57.27 34.6-138.65-20.17-184.59L6.21 573.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "arty_svg__cls-11",
    d: "M21.23 620.29c52.2 16.22 111.23-.63 146.44-46.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "arty_svg__cls-6",
    d: "M225.73 738.53h100.12c17.83 0 32.31 14.48 32.31 32.31v21.02c0 6.23-5.06 11.29-11.29 11.29H225.73c-17.83 0-32.31-14.48-32.31-32.31 0-17.83 14.48-32.31 32.31-32.31z",
    transform: "rotate(180 275.79 770.835)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "arty_svg__cls-9",
    d: "M194.42 738.82l-1 32.02c0 17.77 14.54 32.31 32.31 32.31h100.12c17.77 0 32.31-14.54 32.31-32.31"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "arty_svg__cls-8",
    x: 430.68,
    y: 12.89,
    width: 62.84,
    height: 156.26,
    rx: 31.42,
    ry: 31.42,
    transform: "rotate(45 462.096 91.026)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "arty_svg__cls-8",
    x: 374.16,
    y: -5.72,
    width: 62.84,
    height: 156.26,
    rx: 31.42,
    ry: 31.42,
    transform: "rotate(45 405.578 72.406)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "arty_svg__cls-11",
    d: "M416.4 17.16c12.22-12.22 32.21-12.22 44.43 0 12.22 12.22 12.22 32.21 0 44.43l-50.92 50.92M280.58 210.8c9.98-9.98 23.75-16.18 38.9-16.18 15.15 0 28.91 6.2 38.9 16.18M441 210.8c9.98-9.98 23.75-16.18 38.9-16.18 15.15 0 28.91 6.2 38.9 16.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "arty_svg__cls-5",
    d: "M518.45 635.22V483.45c0-65.53-52.53-119.69-118.06-120.07-65.81-.39-119.47 53.03-119.47 118.76v153.08c0 41.75 33.85 75.6 75.6 75.6h86.33c41.75 0 75.6-33.85 75.6-75.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "arty_svg__cls-2",
    d: "M359.85 587.49c-13.24 9.45-31.62-.02-31.62-16.28v-55.35c0-16.26 18.38-25.73 31.62-16.28l20.53 14.65c20.12 14.36 20.12 44.25 0 58.61l-20.53 14.65zM451.52 587.49c13.24 9.45 31.62-.02 31.62-16.28v-27.67-27.67c0-16.26-18.38-25.73-31.62-16.28l-20.53 14.65c-20.12 14.36-20.12 44.25 0 58.61l20.53 14.65z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f93444",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16,
    d: "M354.05 543.54h103.27"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "arty_svg__cls-2",
    x: 387.52,
    y: 525.38,
    width: 36.32,
    height: 36.32,
    rx: 10,
    ry: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.85 525.38c5.52 0 10 4.48 10 10v16.32c0 5.52-4.48 10-10 10h-16.32c-5.52 0-10-4.48-10-10v-16.32c0-5.52 4.48-10 10-10h16.32m0-16h-16.32c-14.34 0-26 11.66-26 26v16.32c0 14.34 11.66 26 26 26h16.32c14.34 0 26-11.66 26-26v-16.32c0-14.34-11.66-26-26-26z",
    fill: "#f93444"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "arty_svg__cls-5",
    x: 260.01,
    y: 240.56,
    width: 118.93,
    height: 168.19,
    rx: 59.46,
    ry: 59.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "arty_svg__cls-3",
    d: "M329.47 378.75c-16.25 0-29.46-13.22-29.46-29.46v-49.26c0-16.25 13.22-29.46 29.46-29.46s29.46 13.22 29.46 29.46v49.26c0 16.25-13.22 29.46-29.46 29.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "arty_svg__cls-5",
    d: "M339.52 328.12l19.44 11.22c2.67 1.54 6-.38 6-3.46v-22.45c0-3.08-3.33-5-6-3.46l-19.44 11.22c-2.67 1.54-2.67 5.39 0 6.93z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "arty_svg__cls-5",
    x: 426.38,
    y: 240.56,
    width: 107.03,
    height: 168.19,
    rx: 53.52,
    ry: 53.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "arty_svg__cls-3",
    d: "M485.72 378.75c-14.62 0-26.52-13.22-26.52-29.46v-49.26c0-16.25 11.9-29.46 26.52-29.46s26.52 13.22 26.52 29.46v49.26c0 16.25-11.9 29.46-26.52 29.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "arty_svg__cls-5",
    d: "M477.1 327.85l-17.47 11.21c-2.53 1.62-5.84-.19-5.84-3.19v-22.42c0-3 3.32-4.81 5.84-3.19l17.47 11.21c2.33 1.49 2.33 4.89 0 6.39z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "arty_svg__cls-6",
    d: "M376.61 353.79h46.54c14.13 0 25.6 11.47 25.6 25.6v28.99c0 26.97-21.9 48.87-48.87 48.87s-48.87-21.9-48.87-48.87v-28.99c0-14.13 11.47-25.6 25.6-25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "arty_svg__cls-2",
    d: "M399.88 437.26c-17.02 0-30.87-15.39-30.87-34.3v-20.72c0-4.58 3.48-8.45 7.6-8.45h46.54c4.12 0 7.6 3.87 7.6 8.45v20.72c0 18.91-13.85 34.3-30.87 34.3z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 348.59,
    y: 351.92,
    width: 120.2,
    height: 51.32,
    rx: 25.66,
    ry: 25.66,
    fill: "#fed425"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArty);
export default ForwardRef;